import React from 'react';
import { motion } from 'framer-motion';
export function StatsSection() {
  const stats = [{
    value: '24/7',
    label: 'Support Available'
  }, {
    value: '100%',
    label: 'Nationwide UK'
  }, {
    value: '<24hr',
    label: 'Response Time'
  }, {
    value: '100+',
    label: 'Unit Fleet'
  }];
  return <section className="bg-brand-navy py-16 border-y border-white/10" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10" data-id="element-173">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center px-4" data-id="element-174">
              <div className="text-4xl md:text-5xl font-heading font-extrabold text-white mb-2" data-id="element-175">
                {stat.value.replace(/[^0-9]/g, '')}
                <span className="text-brand-amber" data-id="element-176">
                  {stat.value.replace(/[0-9]/g, '')}
                </span>
              </div>
              <div className="text-sm font-medium text-gray-400 uppercase tracking-widest" data-id="element-177">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}